export default {
	errors: {
		e400100: {
			title: 'Attention',
			message: 'Invalid verification code. Please check again.',
		},
		e400101: {
			title: 'Attention',
			message: 'The account needs to be activated first. Check your email.',
		},
		e400102: {
			title: 'Attention',
			message: 'This account does not exist in our platform or has the wrong password. Please check the ones you have entered again.',
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/errors/errors_en-gb.js